import { type GameDefinition } from '@kite/engine';
import { THUMBNAIL_URL } from './content';
import { createChaseCarScene } from './scene';

/**
 * Registry entry for the chase-car game.
 *
 * The whole public surface of the package: an id, a title, a tile and a factory. Everything else here
 * is content and two behaviors, and nothing in it is reachable from the portal, which is what keeps
 * adding a game a one line change in `portal/src/registry.ts`.
 */
export const chaseCarGame: GameDefinition = {
  id: 'chase-car',
  title: 'Chase the Car',
  thumbnail: THUMBNAIL_URL,
  createScene: createChaseCarScene,
};
